/**
 * 公共业务工具类
 */
import { useRoomBaseServer } from 'middle-domain';
import { isWechat } from '@/app-shared/utils/tool';
import { emitter, EMIT_DEFINE } from '@/app-shared/utils/emitter';

/**
 * 过滤地址栏参数
 * @param {*} path
 * @param {*} _next
 */
export function filterAddressParams(path) {
  console.log('wechatjs 看看跳转路径记录------->' + path);
  const newPath = path.indexOf('/v3/') != -1 ? path : process.env.VUE_APP_WEB_KEY + path;
  let search = location.search || '';
  if (
    search.indexOf('user_auth_key') == -1 &&
    search.indexOf('open_id') == -1 &&
    search.indexOf('purpose') == -1 &&
    search.indexOf('nickname') == -1
  ) {
    // 默认的search传递，不做任何处理
  } else {
    // 移除传入的地址 ?a=1&b=2&c=3
    const _strOne = location.search.split('?');
    const _strTwo = _strOne[1] || ''; // ?之后的内容
    const _arr = _strTwo.split('&'); // &之后的分割
    const _newArr = [];
    for (let i = 0; i < _arr.length; i++) {
      if (
        !(
          _arr[i].indexOf('user_auth_key') != -1 ||
          _arr[i].indexOf('open_id') != -1 ||
          _arr[i].indexOf('purpose') != -1 ||
          _arr[i].indexOf('nickname') != -1 ||
          _arr[i].indexOf('head_img_url') != -1 ||
          _arr[i].indexOf('visitor_id') != -1
        )
      ) {
        _newArr.push(_arr[i]);
      }
    }
    search = _newArr.length > 0 ? _newArr.join('&') : '';
  }

  /* prettier-ignore */
  const nextUrl = `${window.location.origin}${newPath}${search ? '?' + search : ''}`;
  console.log('wechatjs 看看当前走入到了哪里_next不为空------->', nextUrl);
  // replaceState 添加或替换历史记录后，浏览器地址栏会变成你传的地址，而页面并不会重新载入或跳转
  // window.history.replaceState(null, null, nextUrl);
  window.location.replace(nextUrl);
}

/**
 *  路由拦截需要的构建登录地址（微信授权回调完成后跳转的地址jump_url）
 *  注意：
  1. 邀请卡绑定邀请关系调用后会立即删除地址栏的 invite_code和 invite_way 参数，
  2. 但是jump_url在删除动作之前就拼接完成，所以jump_url中仍然有invite_code和invite_way这两个参数。
  3. 所以跳转jump_url刷新页面，邀请卡绑定邀请关系会再次调用一遍，后端依赖此次调用更新微信昵称
 * @param {*} to
 * @returns
 */
export function buildLoginAddress(to) {
  //获取地址栏参数、设置请求路径
  let _search = '';
  if (location.search && location.search != '') {
    _search = location.search.split('?')[1];
  }
  const address =
    window.location.origin +
    process.env.VUE_APP_WEB_KEY +
    `${to.path}?purpose=login${_search ? '&' + _search : ''}`;
  return address;
}

/**
 * 引导/强制强制公众号关注检测
基础条件:
  // 1 微信环境
  // 2 非嵌入页
  // 3 支持直播状态：1-直播中，2-预约，5-回放
  // 4 configList['ui.hide_wechat'] == 1
  // 5 未关注过公众号 wechatOaConfig?.existed
  // 6 功能开启 wechatOaConfig?.force_enable == 1
    强制关注公众号生效: wechatOaConfig?.follow_type == 1 && 观看限制免费 && 开了报名表单
    引导关注公众号生效：wechatOaConfig?.follow_type == 1
 * @param {*} option
 *
 */
export async function wechatOaFollowCheck(option = {}) {
  console.log('%c--wechatOaFollowCheck 开始', 'color:blue');
  const roomBaseServer = useRoomBaseServer();
  const wechatOaConfig = roomBaseServer.state.wechatOaConfig;
  let code = -1;
  // 不是微信环境
  if (!isWechat()) {
    console.log('%c--wechatOaFollowCheck 不是微信环境', 'color:blue');
    code = 0;
  } else if (roomBaseServer.state.configList['ui.hide_wechat'] != 1) {
    console.log('%c--wechatOaFollowCheck 未开启微信授权', 'color:blue');
    code = 0;
  } else if (roomBaseServer.state.embedObj.embed) {
    console.log('%c--wechatOaFollowCheck 嵌入页不支持', 'color:blue');
    code = 0;
  }
  // follow_type 关注类型：0开屏提示关注 1预约引导关注 2报名强制关注
  else if (!([1, 2].includes(wechatOaConfig?.follow_type) && wechatOaConfig?.force_enable == 1)) {
    console.log('%c--wechatOaFollowCheck 未开启预约引导关注和报名强制关注公众号能力', 'color:blue');
    code = 0;
  }
  if (code === 0) {
    roomBaseServer.state.wechatOaBiz.followStatus = code;
    return code;
  }

  // 判断openid
  const openId = sessionStorage.getItem('open_id');
  //直播状态 1-直播中，2-预约，3-结束，4-点播，5-回放
  const triggerItem = 'webcasting.webinar_state_' + roomBaseServer.state.watchInitData.webinar.type;
  // "webcasting.webinar_state_1" // 观看直播
  // "webcasting.webinar_state_2" // 开播前预约
  // "webcasting.webinar_state_5" // 观看回放
  if (!roomBaseServer.state.wechatOaConfig?.force_config?.trigger_list?.includes(triggerItem)) {
    console.log('%c--wechatOaFollowCheck 没有匹配到对应到触发行为triggerItem', 'color:blue');
    code = 0;
  } else if (roomBaseServer.state.wechatOaConfig?.existed) {
    console.log('%c--wechatOaFollowCheck 已经关注过公众号了', 'color:blue');
    code = 0;
  } else if (!openId) {
    console.log('%c--wechatOaFollowCheck 没有获取到OpenId', 'color:blue');
    code = 0;
  }
  if (code === 0) {
    roomBaseServer.state.wechatOaBiz.followStatus = code;
    return code;
  }
  // 开启了报名强制关注，开启了报名表单生效
  if (
    wechatOaConfig?.follow_type == 2 &&
    roomBaseServer.state.watchInitData.webinar.reg_form == 1
  ) {
    // 展示 强制提示 公众号二维码
    if (sessionStorage.getItem('open_id')) {
      // 移动端微信环境且有open_id 且开启微信强制关注
      await roomBaseServer.wechatOaHasSubscribed({
        openid: sessionStorage.getItem('open_id'), //待查询人的openid
        business_uid: sessionStorage.getItem('initGrayId') // 待查询B端租户Id
      });
    }
    if (roomBaseServer.state.wechatOaConfig?.existed) {
      console.log('%c--wechatOaFollowCheck 已经关注过公众号了', 'color:blue');
      roomBaseServer.state.wechatOaBiz.followStatus = 0;
      return 0;
    }

    roomBaseServer.state.wechatOaBiz.followStatus = 2;
    emitter.emit(EMIT_DEFINE.wechatOa_qrcode_toOpen, { scene: 2 });
    console.log('%c--wechatOaFollowCheck return 2', 'color:blue');
    return 2;
  }

  if (wechatOaConfig?.follow_type == 1) {
    console.log('%c--wechatOaFollowCheck return 1', 'color:blue');
    roomBaseServer.state.wechatOaBiz.followStatus = 1;
    return 1;
  }
  console.log('%c--wechatOaFollowCheck return 0', 'color:blue');
  roomBaseServer.state.wechatOaBiz.followStatus = 0;
  return 0;
}

/**
 * parseURL 路径转换
 **/
export function parseURL(url) {
  /* let a = document.createElement('a');
   a.href = url;
   return {
     path: a.pathname.replace(/^([^\/])/,'/$1').replace('/upload/', '')
   };*/
  // 如果图片域名不是 saas 的域名，直接返回原路径
  if (
    !(url.indexOf('t-alistatic01.e.vhall.com') > -1) &&
    !(url.indexOf('cnstatic01.e.vhall.com') > -1) &&
    !(url.indexOf('pls-static01.58zhibo.net') > -1)
  ) {
    return {
      path: url
    };
  }
  // 查找/upload/位置，保留之后的路径
  let targetIndex = url.indexOf('/upload/');
  if (targetIndex > 0) {
    return {
      path: url.substr(targetIndex + 8, url.length)
    };
  } else {
    return {
      path: url
    };
  }
}

export function parseUploadUrl(url) {
  if (!url) return '';
  // 查找/upload/位置，保留之后的路径
  const targetIndex = url.indexOf('/upload/');
  return targetIndex > 0 ? url.substr(targetIndex + 8, url.length) : url;
}
